import landscapeCarousel from "components/landscapeCarousel";
import {KidsLandsCapeBreakpoints} from "components/settings/BreakpointSettings";

export default function kidsCarousel(type) {
    try {
        if($('#kids-carousel').length){
            $('.top-components').addClass('has-kids-carousel');
        }

        let endPoint;

        if(type ==="YOUNGER_KIDS"){
            endPoint = "/carousels/homepage/younger_kids/offset/{offset}/limit/{limit}/";
        }else if(type === "KIDS"){
            endPoint = "/carousels/homepage/kids/offset/{offset}/limit/{limit}/";
        }else{
            return;
        }

        landscapeCarousel({
            parentContainer: $('#kids-carousel'),
            options: {
                endPoint
            },
            responsive:KidsLandsCapeBreakpoints
        })
    } catch (e) {
        console.error("Top Stories carousel failed to load: ", e)
    }
}